const nom = document.getElementById("ru-alerte-nom");
const email = document.getElementById("ru-alerte-email");
const telephone = document.getElementById("ru-alerte-tel");
const url = document.getElementById("ru-alerte-url");
const type = document.getElementById("ru-alerte-type");
const prix = document.getElementById("ru-alerte-prix");
const prix_neuf = document.getElementById("ru-alerte-prix-neuf");
const img = document.getElementById("ru-alerte-img");
const product_title = document.getElementById("ru-alerte-product-title");
const marque = document.getElementById("ru-alerte-marque");
const liensimilaire = document.getElementById("ru-alerte-lien-similaire");
const yescontact = document.getElementById("yescontact");
const popup_alerte = document.getElementById("ru-popup_alert");
const ruBuyNow = document.getElementById("ru_buy_now");
const ruBuyNowAncre = document.getElementById("ru_buy_add_cart");
const ruBuyNowDesktop = document.getElementById("ru-product-buy-desktop");
const ruSharePopup = document.getElementById("ru-share-popup");
const ruGoUp = document.getElementById("ru-go-up");
const ruGoUpBtn = document.getElementById("ru-go-up-btn");

//alerte "a venir"

function display_newalert() {
  popup_alerte.classList.remove("d-none");
  all_html.classList.add("over-hiden");
}

function hide_newalert() {
  popup_alerte.classList.add("d-none");
  all_html.classList.remove("over-hiden");
}

function new_alerte() {
  fetch('https://hook.eu1.make.com/1awgewvcuflai8xaco9ouupw21pkxyqc', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'alerte': { 'nom': nom.value, 'email': email.value, 'telephone': telephone.value, 'url': url.value, 'velo': type.value, 'prix': prix.value, 'prix-neuf': prix_neuf.value, 'img': img.value, 'product-title': product_title.value, 'marque': marque.value, 'liensimilaire': liensimilaire.value, 'yescontact': yescontact.checked } })
  })
    .then((resp) => {
      if (resp.status === 200) {
        display_alert(1, "Alerte crée");
        hide_newalert();
      } else {
        display_alert(0, "Erreur lors de la création de l'alerte");
        hide_newalert();
      }
    })
    .catch((error) => {
      display_alert(0, "Erreur lors de la création de l'alerte");
      hide_newalert();
    });
}

function setTextInvalid(input){
  if(!input.value || input.value.match(/(^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$|^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$)/g) ){
      input.setCustomValidity('');
  }else{
      input.setCustomValidity("Numéro de téléphone invalide");
  }
}


//accordeon open
if (window.innerWidth > 1000) {
    let accordions = document.querySelectorAll('.ru-produit-info-accordionTitle');
    accordions.forEach(function(acc) {
      acc.classList.add('is-open');
    });
}

// buy btn sticky mobile
window.addEventListener('scroll', function() {
    if (window.innerWidth < 640 && ruBuyNowAncre) {
      if (ruBuyNowAncre.getBoundingClientRect().top < window.innerHeight - 129) {
          ruBuyNow.classList.remove('ru-product-buy-now');
          ruBuyNow.classList.add('ru-product-buy-now-fix');
      } else {
          ruBuyNow.classList.remove('ru-product-buy-now-fix');
          ruBuyNow.classList.add('ru-product-buy-now');
      }
    }else if (ruBuyNowAncre){
      ruBuyNow.classList.remove('ru-product-buy-now-fix');
      ruBuyNow.classList.add('ru-product-buy-now');
    }
});

// buy btn sticky ordi
window.addEventListener('scroll', function() {
    if (window.innerWidth >= 640 && ruBuyNowAncre && ruBuyNowDesktop ) {
      if (ruBuyNowAncre.getBoundingClientRect().top < window.innerHeight - 300) {
          ruBuyNowDesktop.classList.remove('d-none');
      } else {
          ruBuyNowDesktop.classList.add('d-none');
      }
    }else if (ruBuyNowAncre && ruBuyNowDesktop){
      ruBuyNowDesktop.classList.add('d-none');
    }
});


// scroll to
function ruScrollTo(id) {
    const targetElement = document.getElementById(id);
    if (targetElement) {
        const offset = 150; 
        const targetOffset = targetElement.offsetTop - offset;

        window.scrollTo({
            top: targetOffset,
            behavior: "smooth",
        });
    }
}

//share
function displayShare() {
  ruSharePopup.style.height = '180px';
}

function removeShare() {
  ruSharePopup.style.height = '0';
}

//copy in share
function copyLinkProduct() {
  let linkText = document.getElementById("ru-product-link");
  let tempInput = document.createElement("input");
  tempInput.value = linkText.textContent;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  display_alert(true, "Lien copié !");
  removeShare();
}

//go up
if (ruGoUp){
  window.addEventListener('scroll', function() {
    if (ruGoUp.getBoundingClientRect().top < window.innerHeight) {
      ruGoUpBtn.classList.remove('d-none');
    } else {
      ruGoUpBtn.classList.add('d-none');
    }
  });
}
